import {
  AvailableSubscriptionAddonResource,
  availableSubscriptionAddonResourceSchema,
} from "@client/resources/AvailableSubscriptionAddonResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { array, object } from "yup";

export type FetchAvailableSubscriptionAddonsResponse = ApiResponse<
  AvailableSubscriptionAddonResource[]
>;

const schema = object({
  data: array(availableSubscriptionAddonResourceSchema).required(),
});

export const fetchAvailableSubscriptionAddons =
  async (): Promise<FetchAvailableSubscriptionAddonsResponse> => {
    const response = await fetchData(
      "/dietitian/subscription/current/available-addons",
      APIMethods.GET,
    );

    return await schema
      .validate(response)
      .catch(
        logFetchValidateError(
          "/dietitian/subscription/current/available-addons",
        ),
      );
  };
